import React from 'react';
import usePrices from '../../hooks/usePrices';
import { PAGES, serverPath } from '../../site/routes';
import { SELL_STEPS, FAQ, faqJsonLd } from '../../site/content';
import {
  usePageSeo, Breadcrumbs, PageHeader, Section, Steps, ActionButtons, ArrowLink, TextLink, FaqList, CtaBand, LinkCards
} from '../../site/ui';
import { formatMad } from '../../data/servers';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Vente Kamas Maroc', to: PAGES.sellGuide },
];

const GUIDE_FAQ = [FAQ[1], FAQ[3], FAQ[5], FAQ[7]];

export default function SellGuidePage() {
  const { servers } = usePrices();
  const bestPaid = [...servers].sort((a, b) => b.sell - a.sell).slice(0, 6);

  usePageSeo({
    title: 'Vente Kamas Maroc : vendez vos Kamas Dofus contre des DH | AV Kamas',
    description: "Vente Kamas au Maroc : vendez vos Kamas Dofus, Rétro ou Touch plus cher que chez TryAndJudge, payés par virement sur votre compte marocain.",
    path: PAGES.sellGuide,
    breadcrumbs: BREADCRUMBS,
    jsonLd: [faqJsonLd(GUIDE_FAQ)],
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Guide de vente"
        title={<>Vente Kamas Maroc : <span className="text-yellow-400">vendez vos Kamas contre des DH</span></>}
        intro="Vous avez des Kamas en trop ? La vente de Kamas au Maroc avec AV Kamas vous rapporte plus que TryAndJudge (jusqu'à 1 DH de plus par million), payé par virement sur votre compte bancaire marocain."
      >
        <ActionButtons buyLabel="Acheter des Kamas" sellLabel="Commencer une vente" className="mt-5" />
      </PageHeader>

      <Section title="Comment vendre vos Kamas en 4 étapes" className="pt-0 md:pt-0">
        <Steps steps={SELL_STEPS} />
      </Section>

      <Section className="bg-gray-900/40">
        <div className="grid md:grid-cols-2 gap-6 md:gap-10 text-sm sm:text-base text-gray-300 leading-relaxed">
          <div>
            <h2 className="text-lg sm:text-2xl font-bold text-white mb-2">Vendre ses Kamas au meilleur prix</h2>
            <p>
              Le prix de <strong>vente Kamas</strong> affiché est celui que vous touchez, sans frais cachés. Les serveurs les mieux payés
              aujourd'hui sont Kelerog, Boune et Tiliwan : retrouvez tous les tarifs dans le{' '}
              <TextLink to={PAGES.prices}>tableau des prix</TextLink>.
            </p>
          </div>
          <div>
            <h2 className="text-lg sm:text-2xl font-bold text-white mb-2">Un paiement suivi de bout en bout</h2>
            <p className="mb-3">
              Chaque vente a sa conversation dédiée avec le support : vous voyez le statut de la commande et recevez la preuve de virement.
            </p>
            <ArrowLink to={PAGES.sell}>Commencer une vente de Kamas</ArrowLink>
          </div>
        </div>
      </Section>

      <Section
        title="Les Kamas les mieux payés aujourd'hui"
        intro="Les serveurs où la vente de Kamas rapporte le plus en ce moment."
      >
        <LinkCards
          links={bestPaid.map(s => ({ to: serverPath(s), title: `Vendre des Kamas ${s.name}`, text: `${formatMad(s.sell)} le million · ${s.type}` }))}
        />
        <div className="mt-4"><ArrowLink to={PAGES.prices}>Voir tous les prix des Kamas</ArrowLink></div>
      </Section>

      <Section title="Questions sur la vente de Kamas" className="bg-gray-900/40">
        <FaqList items={GUIDE_FAQ} />
        <div className="mt-4"><ArrowLink to={PAGES.faq}>Toutes les questions fréquentes</ArrowLink></div>
      </Section>

      <CtaBand title="Prêt à vendre vos Kamas ?" text="Indiquez votre serveur et votre RIB, soyez payé en dirhams par virement." />
    </main>
  );
}
